import styled from 'styled-components'

export const Form = styled.form`
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: calc(99% - 300px);
    max-width: 580px;
    width: 90vw;
    /* margin: 0 auto; */
    overflow-y: auto;
    overflow-x: hidden;
    height: 60vh;
`;

export const DivLogo = styled.div`
    height: 40%;
    display: flex;
    align-items: center;
    justify-content: center;
    & img {
        width: 199px;
        height: 120px;
    }
    @media (max-width: 960px) {
        height: 35%;
        img {
            width: 140px;
            height: 84px;
        }
    }
    @media (max-width: 660px) {
        img {
            width: 120px;
            height: 79px;
        }
    }
`;

export const DivInput = styled.div`
    width: 100%;
    display: flex;
    gap: 20px;
    margin: 5px 0px 10px 0px;
`;

export const DivQuestions = styled.div`
    display: flex;
    //align-content: center;
    //justify-content: space-between;
    width: 100%;  
    height: 16px;
    /* padding-left: 465px; */
    justify-content: flex-end;

    & div{
        display: flex;
        align-items: center;
        gap: 5px;

        label {
            color: #F8F9FA;
            margin: 0;
            font-family: Roboto, sans-serif;
            font-weight: normal;
            cursor: pointer;
        }
    }

    .container {
        display: block;
        position: relative;
        padding-left: 20px;
        margin-bottom: 12px;
        cursor: pointer;
        font-size: 12px;
        color: #F8F9FA;
        margin: 0;
        font-family: Roboto, sans-serif;
        font-weight: normal;
    
    }

    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 13px;
        width: 13px;
        background-color: #eee;
        border-radius: 2px;
    }

    .container:hover input ~ .checkmark {
        background-color: #ccc;
    }

    .container .checkmark:after {
        content: "";
        position: absolute;
        display: none;
        left: 3.59px;
        top: 0px;
        width: 3px;
        height: 7px;
        border: solid #004687;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .container input:checked ~ .checkmark:after {
        display: block;
    }
    
    & a {
        color: #F8F9FA;
        font-size: 12px;
        text-decoration: underline;
        font-family: Roboto, sans-serif;
    }
`;

export const DivButtons = styled.div`
    width: 100%;
    display: grid;
    margin-top: 70px;
    justify-content: space-between;
    grid-template-columns: 48% 48%;
    grid-template-areas: 'button1' 'button2';
    @media (max-width: 660px) {
        margin-top: 20px;
    }

    button{
        flex: 1;
        width: 100%;
        height: 38px;
        text-transform: uppercase;
        font-family: Roboto, sans-serif;

        &:nth-child(1) {
            width: 100%;
        }
    }
`;

export const Access = styled.div`
    width: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    margin-top: 30px;

    & a {
        color: #F8F9FA;
        font-size: 12px;
        text-decoration: underline;
        font-family: Roboto, sans-serif;
    }

    & img {
        cursor: pointer;
    }

    /* Tooltip container */
    .tooltip {
    position: relative;
    display: inline-block;
    }

    /* Tooltip text */
    .tooltip .tooltiptext {
    visibility: hidden;
    width: 250px;
    background-color: white;
    color: #004992;
    text-align: center;
    padding: 10px;
    border-radius: 6px;
    font-family: Roboto, sans-serif;
    font-weight: bold;
    font-size: 12px;

    /* Position the tooltip text */
    position: absolute;
    z-index: 1;
    bottom: -150%;
    margin-left: -90px;

    /* Fade in tooltip */
    opacity: 0;
    transition: opacity 0.3s;

    @media (max-width: 660px) {
        z-index: 1;
        bottom: -150%;
        left: -300%;
        &.greek {
            left: -450%;
        }
    }
}

/* Tooltip arrow */
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

`;

export const Img = styled.div`
    border: none;
    margin-left: 10px;

    svg { 
        fill: white
    }
`;

export const PasswordInputDiv = styled.div`
  display: flex;
  width: 100%;

  #eye-icon {
    position: relative;
    z-index: 2;
    top: 13px;
    right: 32px;
  }

  #eye-icon:hover {
    color: #969696;
  }
`;

export const Link = styled.a`

`;